import {isNull, isUndefined, omitBy, pipe} from '@yandex-delivery/utils'

import type {AppConfig, OrderFormState} from '../../../types'
import {DeliveryType} from '../../order-map/types' // fixme: перенести в верхние типы
import {makeDummyItems} from './make-dummy-items'
import {mapToNddFields} from './ndd-mapper'
import {toDefaultRoute} from './to-default-route'
import {toPaymentInfo} from './to-payment-info'
import {toRoute} from './to-route'
import {toRoutePoints} from './to-route-points'

export function toFormRequestBody(formState: OrderFormState, config: AppConfig): OrderFormState {
  const route = toRoute(formState)
  const routePoints = toRoutePoints(formState)
  const paymentInfo = toPaymentInfo(formState)

  const verticalGroupId = config.initialProps?.bduiInitialRequest?.state.vertical_group_id
  const selectedSubMode = config.initialProps?.bduiInitialRequest?.state.selected_submode

  const {
    contacts: _contacts,
    skip_confirmation: _skip_confirmation,
    loaders,
    due_type,
    due_time,
    due_date,
    vertical_group_id,
    selected_submode,
    ndd: _ndd,
    sharing_provider: _sharing_provider,
    package_size: _package_size,
    ...otherFields
  } = formState

  // в конфиге формы грузчики строкой, но ручки принимают числом
  const loadersInt = loaders ? {loaders: parseInt(loaders)} : {}
  const nddFields = formState.selected_submode === DeliveryType.NDD_Self_Pickup ? mapToNddFields(formState) : {}

  const result = {
    ...otherFields,
    ...loadersInt,
    ...nddFields,
    selected_submode: selected_submode ?? selectedSubMode,
    vertical_group_id: vertical_group_id ?? verticalGroupId,
    route: route.length !== 0 ? route : toDefaultRoute(config),
    due_type,
    payment_info: paymentInfo,
    route_points: routePoints,
    due_time: due_type === 'due' ? due_time : null,
    due_date: due_type === 'due' ? due_date : null,
    items: Array.isArray(route) ? makeDummyItems(route) : [],
  }

  return pipe(result, omitBy(isNull), omitBy(isUndefined))
}
